export const MAX_VIDEO_DURATION_SEC = 60;
